module.exports = __webpack_public_path__ + "54b1abfbb22372ea729e098ce9b32777.pdf";